module.exports = __webpack_public_path__ + "img/20190731162459411.d215ad5a.png";